// extracted by mini-css-extract-plugin
module.exports = {"extraText":"unstakeProcess_extraText__RINCG","currentBtn":"unstakeProcess_currentBtn__jG2g7"};